export enum DataValidationMessageType {
    INFO = 1,
    WARN = 2,
    ERROR = 3,
    SUCCESS = 4,
    CUSTOM = 5
}
